<template>

    <div>
        <center>
            <h2 class='title is-3'>Login to Biaggeo</h2>
            <br/>
        </center>

        <div class="card" style='margin:auto;max-width:300px;'>
          <center>
            <br/>
            <img src='@/assets/logo_tiny.png'/>
          </center>
          <div class="card-content">
            <div class="content">

                <b-message v-if="error" type="is-danger">
                    {{error}}
                </b-message>


                <label for='email'>
                    Email Address
                </label>
                <p class='control has-icon'>
                    <input class='input' type='email' name='email' id='email' placeholder='user@email.com' value=''
                        v-model='email'
                        v-validate="'required'"
                    />
                    <i class='fa fa-envelope'></i>
                </p>

                <label for='password'>
                    Password
                </label>
                <p class='control has-icon'>
                    <input class='input' type='password' name='password' id='password' placeholder='password' value=''
                        v-model='password'
                        v-validate="'required'"
                    />
                    <i class='fa fa-lock'></i>
                </p>

                <p class='control'>
                    <a class='button is-primary is-fullwidth'
                        :class="{ 'is-loading': isLoading }"
                        @click="loginClick"
                    >Login</a>
                </p>

                <span>
                    Don't have an account?
                    <router-link to="/register">Register</router-link>
                </span>
            </div>
          </div>
        </div>
    </div>

</template>

<script>
import Vue from 'vue';
console.log('found vue', Vue);

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      isLoading: false,
      error: ''
    }
  },
  methods: {
    loginClick: function() {
      var that = this;

      this.isLoading = true;
      this.error = null;

      this.$http.post(this.$hostname + '/login', {
        email: this.email,
        password: this.password
      }).then(function(response) {

        this.$root.isLoggedIn = true;
        this.$root.user = response.body.user;
        this.$root.token = response.body.token;
        this.$root.saveLoginToken(response.body.token);
        this.$router.push({ path: 'dashboard' });

      }).catch(function(error) {
        if(error.status === 401) {
            this.error = 'The provided email and password are incorrect';
        }
        else {
            this.error = 'Unknown error occurred. Please try again.';
            console.error(error);
        }
      }).finally(function() {
        this.isLoading = false;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Login.vue